import { Color } from '@coast/schemas';
import { isEmpty, isNil } from 'lodash';
import { View } from '@shared/components/View';
import { Tag } from '@shared/components/blocks/lib/tags/tag';
import { API } from '@shared/types/api';
import { WorkflowComponentProps } from './WorkflowComponent';
import { WorkflowComponentWrapper } from './WorkflowComponentWrapper';

interface Props extends WorkflowComponentProps {
  component: API.TagComponent;
}

export function WorkflowTagComponent({
  component,
  initialData,
  showLabel,
  paddingHorizontal,
  iconPad,
  showIcon,
}: Props) {
  const selectedTagGroups: string[][] =
    isNil(initialData) || isEmpty(initialData) ? [] : initialData;
  const displayableTagGroups = selectedTagGroups
    .map(tagGroup => component.options?.filter(option => tagGroup?.includes(option.value)) ?? [])
    .filter(tagGroup => tagGroup.length > 0);

  if (!showLabel && !showIcon) {
    return <WorkflowTagContent displayableTagGroups={displayableTagGroups} />;
  }

  return (
    <WorkflowComponentWrapper
      paddingHorizontal={paddingHorizontal ?? 0}
      iconPad={iconPad ?? 0}
      component={component}
      showLabel={showLabel ?? false}
      showIcon={showIcon}
    >
      <WorkflowTagContent displayableTagGroups={displayableTagGroups} />
    </WorkflowComponentWrapper>
  );
}

function WorkflowTagContent({
  displayableTagGroups,
}: {
  displayableTagGroups: API.TagComponentOption[][];
}) {
  return (
    <>
      {displayableTagGroups.map((tags, index) => (
        <View row flex wrap key={index} marginTop={index === 0 ? 0 : 1.5}>
          {tags.map(tag => (
            <Tag key={tag.value} color={tag.backgroundColor as Color} label={tag.label} />
          ))}
        </View>
      ))}
    </>
  );
}
